import { lazyTree } from '@/api/v4ward/clientserve/repository';
export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      prop: 'group',
      column: [
        {
          label: '上级节点id',
          prop: 'parentId',
          display: false,
          readonly: true,
        },
        {
          label: '上级目录',
          prop: 'parentName',
          disabled: true,
        },
        {
          label: '目录名称',
          prop: 'nodeName',
          maxlength: 30,
          showWordLimit: true,
          rules: [
            {
              required: true,
              message: '请输入目录名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '排序号',
          prop: 'indexNum',
          maxlength: 8,
          showWordLimit: true,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入排序号',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
  ],
};
